<template>
  <div class="card" v-if="isShow()" id="mark-ad">
    <div class="card-body">
      <div v-show="isShowButton()">
        <h3 class="card-title title">
          Маркировка рекламы
          <Popper placement="top" arrow>
            <template #default>
              <span class="form-help ms-1">?</span>
            </template>
            <template #content>
              <p>Маркировка работает со следующими сайтами:</p>
              gb.ru, tefal.ru, auchan.ru, sportmaster.ru,<br> iledebeaute.ru, sokolov.ru, lemanapro.ru, megafon.ru, holodilnik.ru,<br> gulliver.ru, cozyhome.ru, mvideo.ru, eldorado.ru, goldapple.ru, bethowen.ru,<br> braun-russia.ru, tddomovoy.ru, citilink.ru, semicvetic.com,<br> laredoute.ru, erborian.ru, tvoe.ru, r-ulybka.ru, 585zolotoy.ru,<br> beeline.ru, magnit.ru, mts.ru, litres.ru, vseinstrumenti.ru, joom.ru, letbefit.ru,<br> prostoeda.pro, justfood.pro, levelkitchen.com, m-food.ru, online.globus.ru,<br> p-food.ru, sushi-master.ru, ast.wine, dixy.ru, vkusvill.ru, tanukifamily.ru,<br> dominopizza.ru, growfood.pro, market.yandex.ru, aliexpress.ru
            </template>
          </Popper>
        </h3>
        <div class="card-header">
          <ul class="nav nav-tabs card-header-tabs" data-bs-toggle="tabs">
            <li class="nav-item">
              <a href="#tabs-1" class="nav-link active" data-bs-toggle="tab">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-settings me-2"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z" /><path d="M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" /></svg>Авто</a>
            </li>
            <li class="nav-item">
              <a href="#tabs-2" class="nav-link" data-bs-toggle="tab">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-hammer me-2"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M11.414 10l-7.383 7.418a2.091 2.091 0 0 0 0 2.967a2.11 2.11 0 0 0 2.976 0l7.407 -7.385" /><path d="M18.121 15.293l2.586 -2.586a1 1 0 0 0 0 -1.414l-7.586 -7.586a1 1 0 0 0 -1.414 0l-2.586 2.586a1 1 0 0 0 0 1.414l7.586 7.586a1 1 0 0 0 1.414 0z" /></svg>Ручная</a>
            </li>
          </ul>
        </div>
        <div class="tab-content">
          <div class="tab-pane active show" id="tabs-1">
            <MarkAdAuto :payload="{
              post_id: field.getPostId(),
              post_status: field.getPostStatus(),
              post_payload: field.getQuery(),
              is_mark: isMarkAd(),
              channel_id: field.getChannelId(),
              type_id: field.getTypeId()
            }"/>
          </div>
          <div class="tab-pane" id="tabs-2">
            <MarkAdCustom :payload="{
              post_id: field.getPostId(),
              post_payload: field.getQuery(),
              channel_id: field.getChannelId(),
              type_id: field.getTypeId(),
            }"/>
          </div>
          <template v-if="isMarkAd()">
            <div class="mt-3">
              <div class="mark-date">Промаркировано: <span v-html="getMarkDate()"></span></div>
            </div>
          </template>
        </div>
      </div>
      <template v-if="!isAbilityMarkAd()">
        <h4 class="h4">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-tag me-1">
            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
            <path d="M7.5 7.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
            <path d="M3 6v5.172a2 2 0 0 0 .586 1.414l7.71 7.71a2.41 2.41 0 0 0 3.408 0l5.592 -5.592a2.41 2.41 0 0 0 0 -3.408l-7.71 -7.71a2 2 0 0 0 -1.414 -.586h-5.172a3 3 0 0 0 -3 3z" />
          </svg>
          Маркировка этого поста недоступна
        </h4>
      </template>
    </div>
  </div>
</template>

<script>
import "./css/style.css"
import {defineComponent, onMounted, onUnmounted, ref, watch} from "vue"
import MarkAdAuto from "@/modules/post/components/mark_ad_auto/Index"
import MarkAdCustom from "@/modules/post/components/mark_ad_custom/Index"
import Helper from "@/services/Helper"
import Api from "./services/Api"
import Listener from "./services/listener"
import Popper from "@/plugins/popper/index"
import DTBackend from "@/services/DTBackend"

export default defineComponent({
  name: "MarkAd",
  props: {
    payload: {
      type: Object,
      required: true,
    },
  },
  components: {
    MarkAdAuto,
    MarkAdCustom,
    Popper,
  },
  setup(props) {
    let markDate = ref(null)
    let markAd = ref(false)
    let show = ref(false)

    let fields = ref(getFields())

    let field = {
      getPostId: () => {
        return fields.value.post_id
      },
      getPostStatus: () => {
        return fields.value.post_status
      },
      getQuery: () => {
        return fields.value.query
      },
      getChannelId: () => {
        return fields.value.channel_id
      },
      getTypeId: () => {
        return fields.value.type_id
      },
    }

    const loadPostDetails = async () => {
      const resp = await Api.getPost(field.getPostId())
      markAd.value = resp.item?.is_mark_ad === 1
      markDate.value = resp.item?.mark_date
    }

    onMounted(async () => {
      showOff()
      updateFields(props.payload)
      Listener.bindListener(onListener)
      await loadPostDetails()
      showOn()
    })

    onUnmounted(() => {
      Listener.unbindListener(onListener)
      clearFields()
    })
    
    async function onListener() {
      const resp = await Api.getPost(field.getPostId())
      markAd.value = resp.item?.is_mark_ad === 1
      markDate.value = resp.item?.mark_date
    }

    watch(() => props.payload, (val) => {
      updateFields(val)
    })

    function showOn() {
      show.value = true
    }

    function showOff() {
      show.value = false
    }

    function updateFields(data) {
      fields.value.post_id = data.post_id
      fields.value.post_status = data.post_status
      fields.value.query = data.query
      fields.value.channel_id = data.channel_id
      fields.value.type_id = data.type_id
    }

    function isShow() {
      return show.value === true
    }

    function clearFields() {
      let items = getFields()

      for (let key of Object.keys(items)) {
        fields[key] = items[key]
      }
    }

    function getFields() {
      return {
        post_id: null,
        post_status: null,
        query: null,
        channel_id: null,
        type_id: null,
      }
    }

    function isShowButton() {
      return isAbilityMarkAd()
    }

    function isMarkAd() {
      return markAd.value === true
    }

    function getMarkDate() {
      let dt = new DTBackend(markDate.value)
      return  dt.get("%D.%M.%y <span>%H:%I</span>")
    }

    function isAbilityMarkAd() {
      return Helper.inArray(
          [
              field.getPostStatus(),
          ],
          [
            "published",
            "scheduled",
            "draft",
          ]
      )
    }

    return {
      field,
      isShow,
      isShowButton,
      isAbilityMarkAd,
      isMarkAd,
      getMarkDate,
    }
  },
})
</script>
